//自定义组件

import userTree from "../components/common/userTree.vue";
import reportTop from "../../node_modules/common/src/components/sys/reportTop";
import reportTools from "../components/common/reportTools";
import carTool from "../components/common/carTool";
import deviceTool from "../components/common/deviceTool";
import driverTool from "../components/common/driverTool";
import personTool from "../components/common/personTool";
import payTool from "../components/common/payTool";
import timeTool from "../components/common/timeTool";
import selectGroup from "../components/common/selectGroup.vue";
import selectUser from "../components/common/selectUser.vue";
import selectCar from "../components/common/selectCar.vue";
import selectDevice from "../components/common/selectDevice.vue";
import tableForm from "../../node_modules/common/src/components/tableForm";
import selecAlotCCar from "../components/common/selecAlotCCar.vue";
import selectAlotDevice from "../components/common/selectAlotDevice.vue";
import selectPerson from "../components/common/selectPerson.vue";
import selectDriver from "../components/common/selectDriver.vue";
import selectItems from "../components/common/selectItems.vue";
import selectGrid from "../components/common/selectGrid.vue";
import selectFence from "../components/common/selectFence.vue";
import selectPoint from "../components/common/selectPoint.vue";
import selectLine from "../components/common/selectLine.vue";
import lyGroup from "../../node_modules/common/src/components/lyGroup.vue";
import lyItem from "../../node_modules/common/src/components/lyItem.vue";
import Address from "../../node_modules/common/src/components/address";
import lyFormItem from "../../node_modules/common/src/components/lyFormItem.vue";
import lyTable from "../../node_modules/common/src/components/lyTable.vue";
import lykanbanbox from "../../node_modules/common/src/components/lykanbanbox";
import lyList from "../../node_modules/common/src/components/lyList";
import axiosRes from "../../node_modules/common/src/components/axiosRes";
import duration from "../../node_modules/common/src/components/duration";
import lyMap from "../components/map/map";
import downloadTask from "../components/common/downloadTask";
import comMap from "../components/map/comMap";
import pointList from "../components/common/pointList";
import lineList from "../components/common/lineList";
import fenceList from "../components/common/fenceList";

import lyPhoto from "../../node_modules/common/src/components/lyPhoto";
import startEnd from "../../node_modules/common/src/components/startEnd";
import alotItem from "../../node_modules/common/src/components/alotItem";
import selectAlotGroup from "../components/common/selectAlotGroup";
import searchAdd from "../../node_modules/common/src/components/searchAdd";
import blind from "../components/common/blind";
//import selectAddMap from "../components/common/selectAddMap";
import selectAddMap from "../../node_modules/common/src/components/selectAddMap";
import selectMapTool from "../../node_modules/common/src/components/selectMapTool";
import formModel from "../../node_modules/common/src/components/formModel";
import selectTool from "../../node_modules/common/src/components/selectTool";
import lyyymmdd from "../../node_modules/common/src/components/lyyymmdd";
import showHide from "../components/common/showHide";
import selectFlow from "../components/diaodu/selectFlow";
import daoru from "../components/common/daoru";
import lySearch from "../../node_modules/common/src/components/lySearch";
import imgList from "../../node_modules/common/src/components/imgList";
import dataDetail from "../../node_modules/common/src/components/dataDetail";

function plugins(Vue) {
  Vue.component("groupTree", () =>
    import("../components/common/groupTree.vue")
  );
  Vue.component("userTree", userTree);
  Vue.component("reportTop", reportTop);
  Vue.component("reportTools", reportTools);
  Vue.component("carTool", carTool);
  Vue.component("duration", duration);
  Vue.component("deviceTool", deviceTool);
  Vue.component("personTool", personTool);
  Vue.component("payTool", payTool);
  Vue.component("timeTool", timeTool);
  Vue.component("selectGroup", selectGroup);
  Vue.component("selectUser", selectUser);
  Vue.component("selectCar", selectCar);
  Vue.component("selectDevice", selectDevice);
  Vue.component("selectPerson", selectPerson);
  Vue.component("selectItems", selectItems);
  Vue.component("selectGrid", selectGrid);
  Vue.component("lyGroup", lyGroup);
  Vue.component("tableForm", tableForm);
  Vue.component("lyItem", lyItem);
  Vue.component("selectMapTool", selectMapTool);
  Vue.component("lyFormItem", lyFormItem);
  Vue.component("lykanbanbox", lykanbanbox);
  Vue.component("lyList", lyList);
  Vue.component("axiosRes", axiosRes);
  Vue.component("lyMap", lyMap);
  Vue.component("Address", Address);
  Vue.component("comMap", comMap);
  Vue.component("pointList", pointList);
  Vue.component("fenceList", fenceList);
  Vue.component("lineList", lineList);
  Vue.component("lyPhoto", lyPhoto);
  Vue.component("startEnd", startEnd);
  Vue.component("searchAdd", searchAdd);
  Vue.component("blind", blind);
  Vue.component("alotItem", alotItem);
  Vue.component("selectAddMap", selectAddMap);
  Vue.component("lySearch", lySearch);
  Vue.component("selectFence", selectFence);
  Vue.component("selectPoint", selectPoint);
  Vue.component("selectLine", selectLine);
  Vue.component("selecAlotCCar", selecAlotCCar);
  Vue.component("selectAlotDevice", selectAlotDevice);
  Vue.component("selectAlotGroup", selectAlotGroup);
  Vue.component("showHide", showHide);
  Vue.component("formModel", formModel);
  Vue.component("selectTool", selectTool);
  Vue.component("lyTable", lyTable);
  Vue.component("selectFlow", selectFlow);
  Vue.component("lyyymmdd", lyyymmdd);
  Vue.component("selectDriver", selectDriver);
  Vue.component("driverTool", driverTool);
  Vue.component("daoru", daoru);
  Vue.component("downloadTask", downloadTask);
  Vue.component("imgList", imgList);
  Vue.component("dataDetail", dataDetail);
}

export default plugins;



// WEBPACK FOOTER //
// ./src/util/person.js